<template lang="pug">
  <div id="app" @click="handleBodyClick">
    transition(name="fade" :duration="500")
      km-sound-setting-overlay(v-if="!soundSettingFinished" @onFinished="handleSoundSettingFinished")
    transition(name="fade" :duration="500")
      <router-view/>
  </div>
</template>

<script>
import * as constants from '@/constants'
import SoundSettingOverlay from './components/shared/SoundSettingOverlay.vue'

export default {
  name: 'keyboardrill',
  components: {
    'km-sound-setting-overlay': SoundSettingOverlay
  },
  data() {
    return {
      soundSettingFinished: false
    }
  },
  async mounted() {
    await this.$store.dispatch('App/setSoundSettingFinished', false)
    // 特定ページ以外でリロードした場合はトップに戻す
    const isTop = this.$route.path === '/'
    const isSignIn = this.$route.path === '/signIn'
    const isEmbedded = this.$route.path.indexOf('/embedded/') === 0
    if (!constants.IS_DEBUG && !isTop && !isSignIn && !isEmbedded) {
      this.$router.push('/')
    }
  },
  methods: {
    async handleSoundSettingFinished() {
      this.soundSettingFinished = true
      await this.$store.dispatch('App/setSoundSettingFinished', true)
    },
    handleBodyClick() {}
  }
}
</script>

<style lang="scss">
#app {
  position: relative;
  width: 1366px;
  height: 768px;
  border: 1px solid #333;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
